"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const _tagged_template_literal = require("@swc/helpers/_/_tagged_template_literal");
function _templateObject() {
    const data = _tagged_template_literal._([
        "\n  fragment EditorialPageBannerText on EditorialBannerText {\n    text\n    textLinks {\n      title\n      relativeUrl\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal._([
        "\n  fragment EditorialPageProductBoxCarousel on EditorialProductBoxCarousel {\n    __typename\n    headline\n    products {\n      __typename\n      imageUrl\n      productCode\n      formattedPrice {\n        __typename\n        price {\n          __typename\n          basicCataloguePrice\n          currentPrice\n        }\n      }\n      price {\n        price {\n          currentPrice\n        }\n      }\n      labels {\n        labelKey\n        productLabelDomain\n        title\n      }\n      concept {\n        __typename\n        name\n        ratingAverage\n        ratingCount\n        brand {\n          __typename\n          name\n        }\n        conceptCode\n        labels {\n          labelKey\n          productLabelDomain\n          title\n        }\n        products {\n          hexColors\n          colorImageUrl\n          productCode\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal._([
        "\n  fragment EditorialPageBannerModule on EditorialBannerModule {\n    backgroundColor {\n      type\n    }\n    backgroundStorybookColor\n    content {\n      title\n      titleColor\n      titleStorybookColor\n      titleSize\n      showReadMoreOption\n      horizontalAlignment\n      textCollection {\n        ...EditorialPageBannerText\n      }\n    }\n    backgroundType\n    backgroundVideo {\n      autoplayOnScroll\n      id\n      playInLoop\n      type\n    }\n    link {\n      relativeUrl\n      title\n      data {\n        __typename\n        ... on Product {\n          productCode\n          labels {\n            labelKey\n            productLabelDomain\n            title\n          }\n          concept {\n            name\n            products {\n              productCode\n            }\n          }\n          price {\n            price {\n              currentPrice\n            }\n          }\n        }\n      }\n    }\n    backgroundImage {\n      url\n    }\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _tagged_template_literal._([
        "\n  ",
        "\n  ",
        "\n  fragment EditorialPageBanner on EditorialBanner {\n    __typename\n    id\n    layout\n    modules {\n      ...EditorialPageBannerModule\n    }\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.editorialPageProductBoxCarouselFragment = exports.editorialPageBannerFragment = void 0;
var _fetching = require("@ori/fetching");
const editorialPageBannerTextFragment = (0, _fetching.gql)(_templateObject());
const editorialPageProductBoxCarouselFragment = exports.editorialPageProductBoxCarouselFragment = (0, _fetching.gql)(_templateObject1());
const editorialPageBannerModuleFragment = (0, _fetching.gql)(_templateObject2());
const editorialPageBannerFragment = exports.editorialPageBannerFragment = (0, _fetching.gql)(_templateObject3(), editorialPageBannerModuleFragment, editorialPageBannerTextFragment);
